export default {
  GET_ZIPCODE_DATATABLE_DATA: 'GET_ZIPCODE_DATATABLE_DATA',
  CREATE_ZIPCODE: 'CREATE_ZIPCODE'
}
